import { deepMerge } from "../../../../../core/helpers/object-util.js";

const formatNumberWithThousandSeparator = "3";

const headerTh = {
	alignment: {
		horizontal: "center",
		vertical: "center",
	},
	font: {
		bold: true,
	},
};

const bottomBorder = {
	border: { bottom: { style: "thick", color: { rgb: "000000" } } },
};

const dataBaseStyle = {
	alignment: { horizontal: "right" },
};

const titleBaseStyle = {
	alignment: { horizontal: "left" },
	font: { bold: true },
};

const summaryTitleBaseStyle = {
	font: { sz: 15 },
};

export const companyNameStyle = {
	font: { sz: 11, bold: true },
};

export const reportInfoStyle = {
	font: { sz: 9 },
};

export const summaryTitleStyle = deepMerge(
	titleBaseStyle,
	summaryTitleBaseStyle,
);

export const reportTitleStyle = deepMerge(
	headerTh,
	{
		font: { sz: 17 },
	},
	bottomBorder,
);

const closingColumnStyle = {
	border: {
		right: { style: "medium", color: { rgb: "000000" } },
	},
};

const referencePeriodColumnStyle = {
	fill: { fgColor: { rgb: "CCCCCC" } },
};

const currentPeriodColumnStyle = {
	fill: { fgColor: { rgb: "AAAAAA" } },
};

const predictedPeriodColumnStyle = {};

/**
 * Todo: Add JSDoc comment
 */
export function getDataStyleForDepth({ row }) {
	const depth = row.getVisibilityDepth();
	const depthStyle = _getDataStyleForDepthStyle({ depth });

	return deepMerge(dataBaseStyle, depthStyle);
}

/**
 * Todo: Add JSDoc comment
 */
export function getTitleStyleForDepth({ row }) {
	const depth = row.getVisibilityDepth();
	const depthStyle = _getTitleStyleForDepthStyle({ depth });

	return deepMerge(titleBaseStyle, depthStyle);
}

/**
 * Todo: Add JSDoc comment
 */
export function getSummaryStyleForDepth({ row }) {
	const depth = row.getVisibilityDepth();
	const depthStyle = _getSummaryStyleForDepthStyle({ depth });

	return deepMerge(titleBaseStyle, depthStyle);
}

/**
 * Todo: Add JSDoc comment
 */
export function getStyleForHeaderColumn({ column }) {
	return getStyleForColumn({ column, baseStyles: [headerTh, bottomBorder] });
}

/**
 * Todo: Add JSDoc comment
 */
export function getStyleForPropertiesColumn({ column }) {
	return getStyleForColumn({ column });
}

/**
 * Todo: Add JSDoc comment
 */
export function getStyleForColumn({ column, baseStyles = [] }) {
	const columnStyles = baseStyles;

	if (column.isClosing?.()) {
		columnStyles.push(closingColumnStyle);
	}

	if (column.isReferenceForecastColumn?.()) {
		columnStyles.push(referencePeriodColumnStyle);
	}

	if (column.isCurrentPeriodForecastColumn?.()) {
		columnStyles.push(currentPeriodColumnStyle);
	}
	if (column.isPredictedForecastColumn?.()) {
		columnStyles.push(predictedPeriodColumnStyle);
	}

	return deepMerge(...columnStyles);
}

function _getDataStyleForDepthStyle({ depth }) {
	if (depth === 1)
		return {
			border: {
				bottom: { style: "medium", color: { rgb: "000000" } },
			},
		};

	return {};
}

function _getTitleStyleForDepthStyle({ depth }) {
	if (depth === 1)
		return {
			font: { bold: true, sz: 20 },
			border: {
				bottom: { style: "medium", color: { rgb: "000000" } },
			},
		};

	return {};
}

function _getSummaryStyleForDepthStyle({ depth }) {
	switch (depth) {
		case 1: {
			return {
				font: { bold: true },
				border: {
					bottom: { style: "medium", color: { rgb: "000000" } },
				},
			};
		}
		case 2:
		case 3:
		case 4: {
			return {
				font: { bold: true },
			};
		}
		default: {
			return {};
		}
	}
}

/**
 * Todo: Add JSDoc comment
 */
export function getNumberFormatForDataCell({ column }) {
	if (column.hasPercentageFormat() || column.isPercentageColumn()) {
		return "0.00%";
	}

	return formatNumberWithThousandSeparator;
}
